const PIXEL_ID = '2768199583518654' // ← Replace with your actual Meta Pixel ID

let initialized = false

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initPixel() {
  if (initialized) return

  // Standard Meta Pixel base code
  const f = window
  const b = document
  const n = 'script'

  if (f.fbq) return

  const fbq = function (...args: unknown[]) {
    if ((fbq as any).callMethod) {
      ;(fbq as any).callMethod.apply(fbq, args)
    } else {
      ;(fbq as any).queue.push(args)
    }
  } as any

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = [] as unknown[][]

  f.fbq = fbq
  f._fbq = fbq

  const script = b.createElement(n)
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = b.getElementsByTagName(n)[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', PIXEL_ID)
  initialized = true
}

export function trackPageView() {
  if (!initialized) initPixel()
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (!initialized) initPixel()
  window.fbq('track', 'AddToCart', {
    content_name: 'IA Sin Miedo (48 horas)',
    content_type: 'product',
    value: 6.36,
    currency: 'CAD',
  })
}
